<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md6>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<h1>Orders</h1>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Daily</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ order_daily_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Daily report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-cart-outline</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Yesterday
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ order_yesterday_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Yesterday report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-cart-outline</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Last Week
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ order_last_week_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Last week report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-cart-outline</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Last Month
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ order_last_month_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Last month report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-cart-outline</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md12>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">orders</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ order_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Total orders
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-cart-outline</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md6>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<h1>Reservations</h1>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Daily</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ reservation_daily_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Daily report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-calendar</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Yesterday
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ reservation_yesterday_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Yesterday report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-calendar</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Last week
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ reservation_last_week_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Last week report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-calendar</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Last month
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ reservation_last_month_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Last month report
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-calendar</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md12>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Reservations
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ reservation_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Total reservations
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-calendar</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		props: [
			"order_count",
			"order_daily_count",
			"order_yesterday_count",
			"order_last_week_count",
			"order_last_month_count",

			"reservation_count",
			"reservation_daily_count",
			"reservation_yesterday_count",
			"reservation_last_week_count",
			"reservation_last_month_count",
		],
	};
</script>